import { ComponentType, forwardRef, createElement, FunctionComponent } from 'react';
import {
  IPublicTypeNpmInfo,
  IPublicTypeComponentSchema,
  IPublicTypeProjectSchema,
} from '@alilc/lowcode-types';
import { isESModule } from './is-es-module';
import { isReactComponent, acceptsRef, wrapReactClass } from './is-react';
import { isObject } from './is-object';
import { isLowcodeProjectSchema } from './check-types';
import { isComponentSchema } from './check-types/is-component-schema';

type Component = ComponentType<any> | object;
interface LibraryMap {
  [key: string]: string;
}

export function accessLibrary(library: string | Record<string, unknown>) {
  if (typeof library !== 'string') {
    return library;
  }

  return (window as any)[library] || generateHtmlComp(library);
}

export function generateHtmlComp(library: string) {
  // 扩展支持的HTML标签列表
  const supportedHtmlTags = [
    // 原有支持的标签
    'a',
    'img',
    'div',
    'span',
    'svg',
    // 新增支持的HTML标签
    'nav',
    'main',
    'footer',
    'header',
    'section',
    'article',
    'aside',
    'blockquote',
    'figure',
    'figcaption',
    'details',
    'summary',
    'dialog',
    'menu',
    'menuitem',
    'iframe',
    'embed',
    'object',
    'param',
    'source',
    'track',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'video',
    'audio',
    'canvas',
    'map',
    'area',
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'article',
    'aside',
    'blockquote',
    'footer',
    'form',
    'header',
    'table',
    'tbody',
    'thead',
    'tr',
    'td',
    'th',
    'section',
    'ul',
    'ol',
    'li',
    'button',
    'input',
    'textarea',
    'strong',
    'em',
    'b',
    'i',
    'u',
    'small',
    'sub',
    'sup',
    'br',
    'hr',
    'pre',
    'code',
    'label',
    'select',
    'option',
    // SVG相关
    'svg',
    'path',
    'rect',
    'circle',
    'ellipse',
    'line',
    'polyline',
    'polygon',
    'g',
    'defs',
    'linearGradient',
    'radialGradient',
    'stop',
    'use',
    'clipPath',
    'mask',
    // 音频视频相关
    'audio',
    'video',
    // 表单相关
    'form',
    'fieldset',
    'legend',
    'label',
    'input',
    'textarea',
    'select',
    'option',
  ];

  if (supportedHtmlTags.includes(library)) {
    return forwardRef((props, ref) => {
      return createElement(library, { ref, ...props }, props.children);
    });
  }
}

export function getSubComponent(library: any, paths: string[]) {
  const l = paths.length;
  if (l < 1 || !library) {
    return library;
  }
  let i = 0;
  let component: any;
  while (i < l) {
    const key = paths[i]!;
    let ex: any;
    try {
      component = library[key] || component;
    } catch (e) {
      ex = e;
      component = null;
    }
    if (i === 0 && component == null && key === 'default') {
      if (ex) {
        return l === 1 ? library : null;
      }
      component = library;
    } else if (component == null) {
      return null;
    }
    library = component;
    i++;
  }
  return component;
}

function findComponent(libraryMap: LibraryMap, componentName: string, npm?: IPublicTypeNpmInfo) {
  if (!npm) {
    return accessLibrary(componentName);
  }
  // libraryName the key access to global
  // export { exportName } from xxx exportName === global.libraryName.exportName
  // export exportName from xxx   exportName === global.libraryName.default || global.libraryName
  // export { exportName as componentName } from package
  // if exportName == null exportName === componentName;
  // const componentName = exportName.subName, if exportName empty subName donot use
  const exportName = npm.exportName || npm.componentName || componentName;
  const libraryName = libraryMap[npm.package] || exportName;
  const library = accessLibrary(libraryName);
  const paths = npm.exportName && npm.subName ? npm.subName.split('.') : [];
  if (npm.destructuring) {
    paths.unshift(exportName);
  } else if (isESModule(library)) {
    paths.unshift('default');
  }
  return getSubComponent(library, paths);
}

/**
 * 判断是否是一个混合组件，即 components 是一个对象，对象值是 React 组件
 * 示例：
 * {
 *    Button: ReactNode,
 *    Text: ReactNode,
 * }
 */
function isMixinComponent(components: any) {
  if (!isObject(components)) {
    return false;
  }

  return Object.keys(components).some((componentName) =>
    isReactComponent(components[componentName]),
  );
}

export function buildComponents(
  libraryMap: LibraryMap,
  componentsMap: {
    [componentName: string]: IPublicTypeNpmInfo | ComponentType<any> | IPublicTypeComponentSchema;
  },
  createComponent: (
    schema: IPublicTypeProjectSchema<IPublicTypeComponentSchema>,
  ) => Component | null,
) {
  const components: any = {};
  Object.keys(componentsMap).forEach((componentName) => {
    let component = componentsMap[componentName];
    if (component && (isLowcodeProjectSchema(component) || isComponentSchema(component))) {
      if (isComponentSchema(component)) {
        components[componentName] = createComponent({
          version: '',
          componentsMap: [],
          componentsTree: [component],
        });
      } else {
        components[componentName] = createComponent(component);
      }
    } else if (isReactComponent(component)) {
      if (!acceptsRef(component)) {
        component = wrapReactClass(component as FunctionComponent);
      }
      components[componentName] = component;
    } else if (isMixinComponent(component)) {
      components[componentName] = component;
    } else {
      component = findComponent(libraryMap, componentName, component);
      if (component) {
        const isAcceptsRef = acceptsRef(component);
        const isReactComponented = isReactComponent(component);
        if (!isAcceptsRef && isReactComponented) {
          component = wrapReactClass(component as FunctionComponent);
        }
        // @ts-ignore
        const needFixFunctionComponentSet = window.AliLowCodeEngine?.config?.get(
          'needFixFunctionComponentSet',
        );
        if (needFixFunctionComponentSet?.has(componentName)) {
          component = wrapReactClass(component as FunctionComponent);
        }
        components[componentName] = component;
      }
    }
    if (!components[componentName]) {
      components[componentName] = generateHtmlComp(componentName);
    }
  });
  return components;
}

export interface UtilsMetadata {
  name: string;
  npm: {
    package: string;
    version?: string;
    exportName: string;
    subName?: string;
    destructuring?: boolean;
    main?: string;
  };
}

interface LibrayMap {
  [key: string]: string;
}

interface ProjectUtils {
  [packageName: string]: any;
}
export function getProjectUtils(
  librayMap: LibrayMap,
  utilsMetadata: UtilsMetadata[],
): ProjectUtils {
  const projectUtils: ProjectUtils = {};
  if (utilsMetadata) {
    utilsMetadata.forEach((meta) => {
      if (librayMap[meta?.npm?.package]) {
        const lib = accessLibrary(librayMap[meta?.npm.package]);
        if (!lib) {
          console.warn(`Npm Package 加载失败: ${meta?.npm.package} 请检查全局变量名是否正确`);
        } else if (lib?.destructuring) {
          Object.keys(lib).forEach((name) => {
            if (name === 'destructuring') return;
            projectUtils[name] = lib[name];
          });
        } else if (meta.npm.destructuring) {
          Object.keys(lib).forEach((name) => {
            if (name === 'destructuring') return;
            projectUtils[name] = lib[name];
            if (meta.npm.exportName) {
              projectUtils[name] = lib[name]?.[meta.npm.exportName];
            }
          });
        } else if (meta.name) {
          projectUtils[meta.name] = lib;
        }
      }
    });
  }
  return projectUtils;
}
